import DepartmentAPI from '../Api/department';
import { IDepartmentEdit } from '../Shared/interfaces';
import { mapDepartment } from '../Shared/mappers';

export const SET_ERROR = 'SET_DEPARTMENT_ERROR';
export const SET_LIST = 'SET_DEPARTMENT_LIST';
export const SET_LOADING = 'SET_DEPARTMENT_LOADING';

export function create(data: IDepartmentEdit) {
    return async (dispatch: any) => {
        dispatch({
            type: SET_LOADING,
            isLoading: true
        });
        const { result, error } = await DepartmentAPI.create(data);
        if (!result) {
            return dispatch({
                type: SET_ERROR,
                error
            });
        }
        dispatch(getList())
    }
}

export function edit(id: number, data: IDepartmentEdit) {
    return async (dispatch: any) => {
        dispatch({
            type: SET_LOADING,
            isLoading: true
        });
        const { result, error } = await DepartmentAPI.edit(id, data);
        if (!result) {
            return dispatch({
                type: SET_ERROR,
                error
            });
        }
        dispatch(getList())

    }
}

export function getList() {
    return async (dispatch: any) => {
        dispatch({
            type: SET_LOADING,
            isLoading: true
        });
        const { result, error, data } = await DepartmentAPI.getList();
        if (result) {
            return dispatch({
                type: SET_LIST,
                data: mapDepartment(data)
            });
        }
        return dispatch({
            type: SET_ERROR,
            error
        });
    }
}

export function getListByChannel(channelId: number) {
    return async (dispatch: any) => {
        dispatch({
            type: SET_LOADING,
            isLoading: true
        });
        const { result, error, data } = await DepartmentAPI.getListByChannel(channelId);
        if (result) {
            return dispatch({
                type: SET_LIST,
                data: mapDepartment(data)
            });
        }
        return dispatch({
            type: SET_ERROR,
            error
        });
    }
}

export function remove(id: number) {
    return async (dispatch: any) => {
        dispatch({
            type: SET_LOADING,
            isLoading: true
        });
        const { result, error } = await DepartmentAPI.remove(id);
        if (!result) {
            return dispatch({
                type: SET_ERROR,
                error
            });
        }
        dispatch(getList());
    }
}